import ApiService from '@/api/http/ApiService';
import { HealthCheck } from '@/interfaces/models/HealthCheck';
import { Page } from '@/interfaces/api/Page';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import axios, { AxiosPromise } from 'axios';

export default class HealthCheckApiService extends ApiService<HealthCheck> {
  constructor() {
    super('general/foodcard/health-checks', 'v1');
  }

  public getHealthChecks(page: Page, filter: Filter): AxiosPromise<HealthCheck[] | Pagination<HealthCheck>> {
    const customerGroupOrVenuesFilter = filter.customerGroup
      ? { customerGroup: filter.customerGroup }
      : { venues: filter.venues };

    if (page) {
      return axios.get(`${this.getBaseUrl()}`, {
        params: { page, limit: 10, ...customerGroupOrVenuesFilter },
      });
    }

    return axios.get(`${this.getBaseUrl()}`);
  }
}
